import useSWR from 'swr';
import { useMemo } from 'react';
import { NavTabs } from '@shared/tabs/NavTabs';
import { ILenderUtility } from '../interfaces';
import { CREATE_LENDER } from '../LenderUtility';
import { General } from './General/General';
import { CreditRules } from './CreditRules/CreditRules';
import { DocFees } from './DocFees/DocFees';
import { RateCards } from './RateCards/RateCards';
import { IncsAndExcs } from './IncsAndExcs/IncsAndExcs';
import { Assets } from './Assets/Assets';
import { ProductRules } from './ProductRules/ProductRules';
import { StateRules } from './StateRules/StateRules';
import { Formulas } from './Formulas/Formulas';
import { LoanInfo } from './LoanInfo/LoanInfo';
import { AutoSubmit } from './AutoSubmit/AutoSubmit';

interface ILenderUtilityTabsProps {
  lenderId: string;
}

export interface ILenderUtilityTabProps extends ILenderUtilityTabsProps {
  data?: ILenderUtility;
  create?: boolean;
  mutate?: () => void;
}

export const LenderUtilityTabs = ({ lenderId }: ILenderUtilityTabsProps) => {
  const isCreateMode = lenderId === CREATE_LENDER;
  const { data: lenderUtility, error: lenderUtilityError, isValidating, mutate } = useSWR<ILenderUtility>(() => !isCreateMode && `/lender-service/lenders/${lenderId}`);

  const props = {
    data: lenderUtility,
    lenderId,
    create: isCreateMode,
  };

  const tabs = useMemo(() => [
    {
      name: 'General',
      component: <General {...props} mutate={mutate} />,
    },
    {
      name: 'Loan Info',
      component: <LoanInfo {...props} mutate={mutate} />,
      disabled: isCreateMode,
    },
    {
      name: 'Rate Cards',
      component: <RateCards {...props} mutate={mutate} />,
      disabled: isCreateMode,
    },
    {
      name: 'Auto Submit',
      component: <AutoSubmit {...props} />,
      disabled: isCreateMode,
    },
    {
      name: 'Incs and Excs',
      component: <IncsAndExcs {...props} />,
      disabled: isCreateMode,
    },
    {
      name: 'State Rules',
      component: <StateRules {...props} />,
      disabled: isCreateMode,
    },
    {
      name: 'Assets',
      component: <Assets {...props} />,
      disabled: isCreateMode,
    },
    {
      name: 'Doc Fees',
      component: <DocFees {...props} />,
      disabled: isCreateMode,
    },
    {
      name: 'Product Rules',
      component: <ProductRules {...props} mutate={mutate}/>,
      disabled: isCreateMode,
    },
    {
      name: 'Credit Rules',
      component: <CreditRules {...props} />,
      disabled: isCreateMode,
    },
    {
      name: 'Formulas',
      component: <Formulas {...props} />,
      disabled: isCreateMode,
    },
  ], [props, isCreateMode]);

  const isLoading = Boolean((!lenderUtility && !lenderUtilityError && !isCreateMode) || isValidating);

  return (
    <NavTabs 
      data={tabs} 
      loading={isLoading} 
    />
  );
};
